/** @format */

import React, { PureComponent } from 'react';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FilterManager } from '../../modules/filter/FilterManager';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import PaperedTable from '../../components/Table/PaperedTable';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import Pager from '../../components/Adescom/PagerRange';
import { TableFooter } from '@material-ui/core';
import FilterList from '../../components/Filter/FilterList';
import { history } from '../../core/history';
import { StorageIpSuperUserItem } from './views/StorageIpSuperUserItem';
import { PlatformIpPoolNumberCollectionInterface } from '../../interfaces/platform/PlatformIpPoolNumber';
import { IpStateSimpleHelper } from '../lib/search/IpStateSimpleHelper';
import { StorageIpPartnerUserItem } from './views/StorageIpPartnerUserItem';
import { StorageIpToCsv } from '../../modules/storage/StorageIpToCsv';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { IpChangeOwner } from './ip/IpChangeOwner';
import { NotificationHelper } from '../../helpers/NotificationHelper';

interface StorageIpStateInterface {
    poolNumbers: PlatformIpPoolNumberCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    showClearFilterButton: boolean;
    searchSendWithFitler: boolean;
    activeRow: number;
    openChangeOwner: boolean;
}

class StorageIp extends PureComponent<ListPropsInterface, StorageIpStateInterface> {
    private loaderCall: ItemLoaders;
    private filterManage: FilterManager;
    private ipStateSimpleHelper: IpStateSimpleHelper;

    constructor(props: ListPropsInterface, context: StorageIpStateInterface) {
        super(props, context);
        this.state = {
            poolNumbers: null,
            orders: [],
            filters: [],
            activeRow: 0,
            searchSendWithFitler: false,
            showClearFilterButton: false,
            openChangeOwner: false,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
        this.ipStateSimpleHelper = new IpStateSimpleHelper();
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {
            this.firstLoad();
        });
    }

    componentDidUpdate(prevProps: Readonly<ListPropsInterface>, prevState: Readonly<StorageIpStateInterface>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            const { searchSendWithFitler } = this.state;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
            if (searchSendWithFitler) {
                this.firstLoad();
            }
        });
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                orders: [{ name: 'ip', value: 'asc' }],
                filters: [{ name: 'deleted', value: false }],
            },
            (): void => {
                callback();
            }
        );
    };

    firstLoad = (): void => {
        const { orders, showClearFilterButton } = this.state;
        const { dispatch, showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_ip_pool_numbers')),
            'storage_ip_loader_items',
            this.prepareFiltersList(),
            orders,
            (items: PlatformIpPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items, searchSendWithFitler: showClearFilterButton });
                showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    prepareFiltersList = (): Array<Filter> => {
        const { filters } = this.state;
        const newFilters: Array<Filter> = [];
        filters.map((f) => {
            if (f.name === 'ip' && typeof f.value === 'string') {
                if (/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/.test(f.value)) {
                    newFilters.push(f);
                } else if (/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/.test(f.value)) {
                    newFilters.push({ name: 'ipRange[min]', value: f.value + '.0' }, { name: 'ipRange[max]', value: f.value + '.255' });
                } else if (/^[0-9]{1,3}\.[0-9]{1,3}/.test(f.value)) {
                    newFilters.push({ name: 'ipRange[min]', value: f.value + '.0.0' }, { name: 'ipRange[max]', value: f.value + '.255.255' });
                } else if (/^[0-9]{1,3}/.test(f.value)) {
                    newFilters.push({ name: 'ipRange[min]', value: f.value + '.0.0.0' }, { name: 'ipRange[max]', value: f.value + '.255.255.255' });
                }
            } else {
                newFilters.push(f);
            }
        });
        return newFilters;
    };

    paginationCallbackFunction = (uri: string): void => {
        const { showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            'storage_ip_loader_items',
            (items: PlatformIpPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items });
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    exportToCsv = (): void => {
        const { filters, orders, poolNumbers } = this.state;
        const { showMainLoader, dispatch } = this.props;
        if (poolNumbers && !poolNumbers['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        const toCsv = new StorageIpToCsv(this.loaderCall, new PlatformResellerLoader(this.loaderCall), this.ipStateSimpleHelper);
        toCsv.exportToCsv(
            (UserRoleHelper.checkRole(roles.ROLE_PLATFORM_IP_POOL_NUMBER_GET) &&
                !UserRoleHelper.checkRole(roles.ROLE_IP_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                UserRoleHelper.checkRole(roles.ROLE_SUPERUSER),
            orders,
            filters,
            showMainLoader
        );
    };

    viewCallback = (iri: { uri: string }, event: any): void => this.pushCallback('/ip-common' + iri.uri, event);

    pushCallback = (uri: string, event: any): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, FormGeneralHelper.getRouteUrl(uri));
    };

    viewPoolManager = (iri: { uri: string }, event: any): void => this.pushCallback('/ip-pool-manage', event);

    render(): React.ReactNode {
        const { classes } = this.props;
        const { showClearFilterButton, poolNumbers, filters, orders, activeRow, openChangeOwner } = this.state;
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size="lg"
                                    />
                                    {UserRoleHelper.checkRole(roles.ROLE_UPLOAD_IP_POOLS) && (
                                        <CustomTextButtom
                                            callback={this.viewPoolManager}
                                            callbackParam={{ uri: 'no-uri' }}
                                            color="primary"
                                            label="pools:msisdn.pool_manage"
                                            size="lg"
                                        />
                                    )}
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_IP_POOLS_CHANGE_OWNER_PUT) && (
                                        <React.Fragment>
                                            <CustomTextButtom
                                                callback={(): void => this.setState({ openChangeOwner: true })}
                                                callbackParam={{}}
                                                color="primary"
                                                label="pools:apn.owner_change"
                                                size="lg"
                                            />
                                        </React.Fragment>
                                    )}

                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        {((UserRoleHelper.checkRole(roles.ROLE_PLATFORM_IP_POOL_NUMBER_GET) &&
                            !UserRoleHelper.checkRole(roles.ROLE_IP_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                            UserRoleHelper.checkRole(roles.ROLE_SUPERUSER)) &&
                            poolNumbers && (
                                <StorageIpSuperUserItem
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    ipStateSimpleHelper={this.ipStateSimpleHelper}
                                />
                            )}
                        {UserRoleHelper.checkRole(roles.ROLE_IP_PLATFORM_POOL_NUMBER_PARTNER_VIEW) &&
                            !UserRoleHelper.checkRole(roles.ROLE_SUPERUSER) &&
                            poolNumbers && (
                                <StorageIpPartnerUserItem
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    ipStateSimpleHelper={this.ipStateSimpleHelper}
                                />
                            )}
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {poolNumbers && poolNumbers['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={poolNumbers} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                    <IpChangeOwner open={openChangeOwner} close={(): void => this.setState({ openChangeOwner: false })} reload={this.firstLoad} />
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(OplAppStyle))(StorageIp);
